// extracted by mini-css-extract-plugin
module.exports = {"blob":"CoverBlob_blob__P2nFT","image":"CoverBlob_image__zmYfo","illustration":"CoverBlob_illustration__gXJib"};